import { NoTranslate } from "@/core/components/ui/no-translate";
import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { cn } from "@/core/utils/func/cn";

export function Logo({ className }: { className?: string }) {
  const { t } = useTypedTranslation();

  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <img src="/flash_pay_logo.png" alt={t("app.name")} className="size-9" />
      <NoTranslate as="span" className="text-xl font-bold">
        {t("app.name")}
      </NoTranslate>
    </div>
  );
}
